'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Button = function Button(_ref) {
  var _classnames;

  var env = _ref.env,
      type = _ref.type,
      weight = _ref.weight,
      size = _ref.size,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      text = _ref.text,
      icon = _ref.icon,
      qaId = _ref.qaId;

  var iconOnly = icon && text === undefined;

  var buttonClass = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _styles2.default['button'], true), _defineProperty(_classnames, _styles2.default['button--' + env], env), _defineProperty(_classnames, _styles2.default['button--' + type], type), _defineProperty(_classnames, _styles2.default['button--' + weight], weight), _defineProperty(_classnames, _styles2.default['button--icon-only'], iconOnly), _defineProperty(_classnames, _styles2.default['button--' + size], size), _classnames));
  return _react2.default.createElement(
    'button',
    {
      className: buttonClass,
      disabled: disabled,
      onClick: onClick,
      'data-qa-id': qaId,
      'data-hudl-element': qaId
    },
    icon,
    _react2.default.createElement(
      'span',
      { className: _styles2.default.button__text },
      text
    )
  );
};

Button.propTypes = {
  env: _react.PropTypes.oneOf(['light', 'dark']),
  type: _react.PropTypes.oneOf(['primary', 'secondary', 'success', 'destructive']),
  weight: _react.PropTypes.oneOf(['block', 'normal', 'reduced']),
  size: _react.PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: _react.PropTypes.bool,
  onClick: _react.PropTypes.func,
  qaId: _react.PropTypes.string,
  text: _react.PropTypes.string,
  icon: _react.PropTypes.element
};

Button.defaultProps = {
  env: 'light',
  type: 'primary',
  weight: 'normal',
  size: 'medium',
  disabled: false,
  onClick: function onClick() {}
};

exports.default = Button;